/// <amd-module name="Repos/Tfvc/Views/FilesHub/Components/InvalidPath" />
import * as React from "react";
import { isLatest } from "Repos/Common/Util/Version";
import * as Resources from "Repos/Tfvc/Views/FilesHub/Resources";
import { format } from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Observer } from "VSSUI/Observer";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { ZeroData, ZeroDataActionType } from "VSSUI/ZeroData";
import { getFilesHubViewService, registerFilesHubTab } from "../FilesHubViewService";

export class InvalidPath extends VssComponent<{}> {
    public render() {
        const filesService = getFilesHubViewService(this.context.pageContext);

        const path = filesService.getSelectedItem().value.path;
        const version = filesService.getVersion();

        const message = format(Resources.InvalidFileMessageFormat, path);

        let actionText: string;
        let actionHref: string | undefined;
        let onActionClick: { (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>): void } | undefined;

        if (isLatest(version)) {
            const rootItem = filesService.getRootItem();
            actionText = Resources.GoToRepositoryRoot;
            actionHref = filesService.getItemUrl(rootItem.path);
            onActionClick = (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
                filesService.setSelectedPath(rootItem.path);
                event.preventDefault();
            };
        } else {
            actionText = Resources.GoToLatestVersion;
            actionHref = filesService.getItemUrl(path, { version: "T" });
        }

        return (
            <ZeroData
                className="flex-grow"
                imagePath={getAssetLocation(this.context.pageContext, "ms.vss-code-web/tfvc-files-hub-content/Content/invalid-path.svg")}
                imageAltText={message}
                primaryText={Resources.InvalidFileTitle}
                secondaryText={message}
                actionType={ZeroDataActionType.ctaButton}
                actionText={actionText}
                actionHref={actionHref}
                onActionClick={onActionClick}
            />
        );
    }
}

registerFilesHubTab({
    getTab: (pageContext, item) => {
        if (item.isInvalid && !item.isNewItem) {
            return {
                id: "contents",
                name: Resources.Contents,
                order: 10,
                render: () => {
                    const loadedFolders = getFilesHubViewService(pageContext).getLoadedFolders();
                    if (loadedFolders.length === 0) {
                        // No initial data so invalid is not reliable, let's wait for first fetch to complete
                        // Render Observer only on this case to not impact happy path performance.
                        return (
                            <Observer {...{ loadedFolders }}>
                                {() => {
                                    return loadedFolders.length === 0 ? <Spinner size={SpinnerSize.large} /> : <InvalidPath />;
                                }}
                            </Observer>
                        );
                    } else {
                        return <InvalidPath />;
                    }
                }
            };
        }
    }
});
